
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    if (!router) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    for (const route of mod.default || mod) {
      router.addRoute(route)
    }
    router.replace('')
  })
}

export function handleHotUpdate(_router) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
  }
}
import { default as indexhlkLmcalOBMeta } from "/codebuild/output/src3107083106/src/pages/index.vue?macro=true";
import { default as aboutzIQWcVRHDeMeta } from "/codebuild/output/src3107083106/src/pages/about.vue?macro=true";
import { default as datare1lMM65bBMeta } from "/codebuild/output/src3107083106/src/pages/account-settings/data.vue?macro=true";
import { default as manage_45subscriptioncWDGq4bTojMeta } from "/codebuild/output/src3107083106/src/pages/account-settings/manage-subscription.vue?macro=true";
import { default as positioningzpOB5anK2VMeta } from "/codebuild/output/src3107083106/src/pages/account-settings/positioning.vue?macro=true";
import { default as privacysi7rHpYlz9Meta } from "/codebuild/output/src3107083106/src/pages/account-settings/privacy.vue?macro=true";
import { default as remove_45accountZAiv1GS0YnMeta } from "/codebuild/output/src3107083106/src/pages/account-settings/remove-account.vue?macro=true";
import { default as statue8ag1QX5jdVMeta } from "/codebuild/output/src3107083106/src/pages/account-settings/statue.vue?macro=true";
import { default as supportQvxKWsP0KoMeta } from "/codebuild/output/src3107083106/src/pages/account-settings/support.vue?macro=true";
import { default as account_45settingsMZkJFRbGAuMeta } from "/codebuild/output/src3107083106/src/pages/account-settings.vue?macro=true";
import { default as activate_45accountWaZpRe4sx9Meta } from "/codebuild/output/src3107083106/src/pages/activate-account.vue?macro=true";
import { default as company8jeE9Ozi4HMeta } from "/codebuild/output/src3107083106/src/pages/admin/company.vue?macro=true";
import { default as consentsRzoka9viH3Meta } from "/codebuild/output/src3107083106/src/pages/admin/consents.vue?macro=true";
import { default as leadsbN3lyKu2kYMeta } from "/codebuild/output/src3107083106/src/pages/admin/leads.vue?macro=true";
import { default as payments0gObcmNavtMeta } from "/codebuild/output/src3107083106/src/pages/admin/payments.vue?macro=true";
import { default as premiumHWDOsd86UeMeta } from "/codebuild/output/src3107083106/src/pages/admin/premium.vue?macro=true";
import { default as profilesPwP8aEh1KuMeta } from "/codebuild/output/src3107083106/src/pages/admin/profiles.vue?macro=true";
import { default as usersMvpEns61RVMeta } from "/codebuild/output/src3107083106/src/pages/admin/users.vue?macro=true";
import { default as change_45password2ELJJL3eBFMeta } from "/codebuild/output/src3107083106/src/pages/change-password.vue?macro=true";
import { default as _91id_93RTuqx4jeCgMeta } from "/codebuild/output/src3107083106/src/pages/chat/[id].vue?macro=true";
import { default as aiMtmaoDalYdMeta } from "/codebuild/output/src3107083106/src/pages/chat/ai.vue?macro=true";
import { default as indexouP9xF6C1rMeta } from "/codebuild/output/src3107083106/src/pages/chat/index.vue?macro=true";
import { default as chatt8owFJluyJMeta } from "/codebuild/output/src3107083106/src/pages/chat.vue?macro=true";
import { default as _91id_93yiOe0D5BysMeta } from "/codebuild/output/src3107083106/src/pages/client/profile/[id].vue?macro=true";
import { default as index2rTWkhp226Meta } from "/codebuild/output/src3107083106/src/pages/client/profile/index.vue?macro=true";
import { default as _91id_93gH0g6juG0eMeta } from "/codebuild/output/src3107083106/src/pages/contacts/[id].vue?macro=true";
import { default as indexxucELfRYhiMeta } from "/codebuild/output/src3107083106/src/pages/contacts/index.vue?macro=true";
import { default as contactsaHRPaC9duWMeta } from "/codebuild/output/src3107083106/src/pages/contacts.vue?macro=true";
import { default as _91userId_93uITsG3PdWRMeta } from "/codebuild/output/src3107083106/src/pages/delete-mailing/[email]/[userId].vue?macro=true";
import { default as indexqaIlNMRcB4Meta } from "/codebuild/output/src3107083106/src/pages/login/index.vue?macro=true";
import { default as register_45success7MceEp9INOMeta } from "/codebuild/output/src3107083106/src/pages/login/register-success.vue?macro=true";
import { default as loginsJwveiBknHMeta } from "/codebuild/output/src3107083106/src/pages/login.vue?macro=true";
import { default as logoutwpfPAmsAzFMeta } from "/codebuild/output/src3107083106/src/pages/logout.vue?macro=true";
import { default as consentsgGJNNNHtFFMeta } from "/codebuild/output/src3107083106/src/pages/manager/consents.vue?macro=true";
import { default as integrations0IUq0AxXq8Meta } from "/codebuild/output/src3107083106/src/pages/manager/integrations.vue?macro=true";
import { default as leads18fB1uyBbgMeta } from "/codebuild/output/src3107083106/src/pages/manager/leads.vue?macro=true";
import { default as paymentsN9uHDXlzzZMeta } from "/codebuild/output/src3107083106/src/pages/manager/payments.vue?macro=true";
import { default as profilev3jTCgIfYpMeta } from "/codebuild/output/src3107083106/src/pages/manager/profile.vue?macro=true";
import { default as teamH9P5hygSGxMeta } from "/codebuild/output/src3107083106/src/pages/manager/team.vue?macro=true";
import { default as indexgqDKULQpMaMeta } from "/codebuild/output/src3107083106/src/pages/marketplace/index.vue?macro=true";
import { default as _91catId_93_46clienttyfR4HsRzGMeta } from "/codebuild/output/src3107083106/src/pages/marketplace/search/[catId].client.vue?macro=true";

let _createClientPage
async function createClientPage(loader) {
  _createClientPage ||= await import("/codebuild/output/src3107083106/src/node_modules/nuxt/dist/components/runtime/client-component.js").then(r => r.createClientPage)
  return _createClientPage(loader);
}
import { default as marketplaceczvRPw0GanMeta } from "/codebuild/output/src3107083106/src/pages/marketplace.vue?macro=true";
import { default as subscriber6fPE7EfbtMeta } from "/codebuild/output/src3107083106/src/pages/newsletter/subscribe.vue?macro=true";
import { default as find_46client7iVhTlkgCZMeta } from "/codebuild/output/src3107083106/src/pages/orders/find.client.vue?macro=true";
import { default as my_46clientkWD3z4TJfeMeta } from "/codebuild/output/src3107083106/src/pages/orders/my.client.vue?macro=true";
import { default as privacyRn7vsTG28rMeta } from "/codebuild/output/src3107083106/src/pages/privacy.vue?macro=true";
import { default as indexVePs0vlrVhMeta } from "/codebuild/output/src3107083106/src/pages/recover/index.vue?macro=true";
import { default as successhmYAv0CDvQMeta } from "/codebuild/output/src3107083106/src/pages/register/success.vue?macro=true";
import { default as _91id_93VH4mjGPNt2Meta } from "/codebuild/output/src3107083106/src/pages/sales/profile/[id].vue?macro=true";
import { default as indexC9VJ54uKQaMeta } from "/codebuild/output/src3107083106/src/pages/sales/profile/index.vue?macro=true";
import { default as statueMShFAknGf4Meta } from "/codebuild/output/src3107083106/src/pages/statue.vue?macro=true";
import { default as successynOBLG297JMeta } from "/codebuild/output/src3107083106/src/pages/subscription/success.vue?macro=true";
import { default as component_45stub6GkjTze17uMeta } from "/codebuild/output/src3107083106/src/node_modules/nuxt/dist/pages/runtime/component-stub.js?macro=true";
import { default as component_45stub6GkjTze17u } from "/codebuild/output/src3107083106/src/node_modules/nuxt/dist/pages/runtime/component-stub.js";
export default [
  {
    name: "index",
    path: "/",
    meta: indexhlkLmcalOBMeta || {},
    component: () => import("/codebuild/output/src3107083106/src/pages/index.vue")
  },
  {
    name: "about___en",
    path: "/en/about",
    meta: aboutzIQWcVRHDeMeta || {},
    component: () => import("/codebuild/output/src3107083106/src/pages/about.vue")
  },
  {
    name: "about___pl",
    path: "/pl/about",
    meta: aboutzIQWcVRHDeMeta || {},
    component: () => import("/codebuild/output/src3107083106/src/pages/about.vue")
  },
  {
    name: "account-settings___en",
    path: "/en/account-settings",
    meta: account_45settingsMZkJFRbGAuMeta || {},
    component: () => import("/codebuild/output/src3107083106/src/pages/account-settings.vue"),
    children: [
  {
    name: "account-settings-data___en",
    path: "data",
    component: () => import("/codebuild/output/src3107083106/src/pages/account-settings/data.vue")
  },
  {
    name: "account-settings-manage-subscription___en",
    path: "manage-subscription",
    component: () => import("/codebuild/output/src3107083106/src/pages/account-settings/manage-subscription.vue")
  },
  {
    name: "account-settings-positioning___en",
    path: "positioning",
    component: () => import("/codebuild/output/src3107083106/src/pages/account-settings/positioning.vue")
  },
  {
    name: "account-settings-privacy___en",
    path: "privacy",
    component: () => import("/codebuild/output/src3107083106/src/pages/account-settings/privacy.vue")
  },
  {
    name: "account-settings-remove-account___en",
    path: "remove-account",
    component: () => import("/codebuild/output/src3107083106/src/pages/account-settings/remove-account.vue")
  },
  {
    name: "account-settings-statue___en",
    path: "statue",
    component: () => import("/codebuild/output/src3107083106/src/pages/account-settings/statue.vue")
  },
  {
    name: "account-settings-support___en",
    path: "support",
    component: () => import("/codebuild/output/src3107083106/src/pages/account-settings/support.vue")
  }
]
  },
  {
    name: "account-settings___pl",
    path: "/pl/account-settings",
    meta: account_45settingsMZkJFRbGAuMeta || {},
    component: () => import("/codebuild/output/src3107083106/src/pages/account-settings.vue"),
    children: [
  {
    name: "account-settings-data___pl",
    path: "data",
    component: () => import("/codebuild/output/src3107083106/src/pages/account-settings/data.vue")
  },
  {
    name: "account-settings-manage-subscription___pl",
    path: "manage-subscription",
    component: () => import("/codebuild/output/src3107083106/src/pages/account-settings/manage-subscription.vue")
  },
  {
    name: "account-settings-positioning___pl",
    path: "positioning",
    component: () => import("/codebuild/output/src3107083106/src/pages/account-settings/positioning.vue")
  },
  {
    name: "account-settings-privacy___pl",
    path: "privacy",
    component: () => import("/codebuild/output/src3107083106/src/pages/account-settings/privacy.vue")
  },
  {
    name: "account-settings-remove-account___pl",
    path: "remove-account",
    component: () => import("/codebuild/output/src3107083106/src/pages/account-settings/remove-account.vue")
  },
  {
    name: "account-settings-statue___pl",
    path: "statue",
    component: () => import("/codebuild/output/src3107083106/src/pages/account-settings/statue.vue")
  },
  {
    name: "account-settings-support___pl",
    path: "support",
    component: () => import("/codebuild/output/src3107083106/src/pages/account-settings/support.vue")
  }
]
  },
  {
    name: "activate-account___en",
    path: "/en/activate-account",
    meta: activate_45accountWaZpRe4sx9Meta || {},
    component: () => import("/codebuild/output/src3107083106/src/pages/activate-account.vue")
  },
  {
    name: "activate-account___pl",
    path: "/pl/activate-account",
    meta: activate_45accountWaZpRe4sx9Meta || {},
    component: () => import("/codebuild/output/src3107083106/src/pages/activate-account.vue")
  },
  {
    name: "admin-company___en",
    path: "/en/admin/company",
    meta: company8jeE9Ozi4HMeta || {},
    component: () => import("/codebuild/output/src3107083106/src/pages/admin/company.vue")
  },
  {
    name: "admin-company___pl",
    path: "/pl/admin/company",
    meta: company8jeE9Ozi4HMeta || {},
    component: () => import("/codebuild/output/src3107083106/src/pages/admin/company.vue")
  },
  {
    name: "admin-consents___en",
    path: "/en/admin/consents",
    meta: consentsRzoka9viH3Meta || {},
    component: () => import("/codebuild/output/src3107083106/src/pages/admin/consents.vue")
  },
  {
    name: "admin-consents___pl",
    path: "/pl/admin/consents",
    meta: consentsRzoka9viH3Meta || {},
    component: () => import("/codebuild/output/src3107083106/src/pages/admin/consents.vue")
  },
  {
    name: "admin-leads___en",
    path: "/en/admin/leads",
    meta: leadsbN3lyKu2kYMeta || {},
    component: () => import("/codebuild/output/src3107083106/src/pages/admin/leads.vue")
  },
  {
    name: "admin-leads___pl",
    path: "/pl/admin/leads",
    meta: leadsbN3lyKu2kYMeta || {},
    component: () => import("/codebuild/output/src3107083106/src/pages/admin/leads.vue")
  },
  {
    name: "admin-payments___en",
    path: "/en/admin/payments",
    meta: payments0gObcmNavtMeta || {},
    component: () => import("/codebuild/output/src3107083106/src/pages/admin/payments.vue")
  },
  {
    name: "admin-payments___pl",
    path: "/pl/admin/payments",
    meta: payments0gObcmNavtMeta || {},
    component: () => import("/codebuild/output/src3107083106/src/pages/admin/payments.vue")
  },
  {
    name: "admin-premium___en",
    path: "/en/admin/premium",
    meta: premiumHWDOsd86UeMeta || {},
    component: () => import("/codebuild/output/src3107083106/src/pages/admin/premium.vue")
  },
  {
    name: "admin-premium___pl",
    path: "/pl/admin/premium",
    meta: premiumHWDOsd86UeMeta || {},
    component: () => import("/codebuild/output/src3107083106/src/pages/admin/premium.vue")
  },
  {
    name: "admin-profiles___en",
    path: "/en/admin/profiles",
    meta: profilesPwP8aEh1KuMeta || {},
    component: () => import("/codebuild/output/src3107083106/src/pages/admin/profiles.vue")
  },
  {
    name: "admin-profiles___pl",
    path: "/pl/admin/profiles",
    meta: profilesPwP8aEh1KuMeta || {},
    component: () => import("/codebuild/output/src3107083106/src/pages/admin/profiles.vue")
  },
  {
    name: "admin-users___en",
    path: "/en/admin/users",
    meta: usersMvpEns61RVMeta || {},
    component: () => import("/codebuild/output/src3107083106/src/pages/admin/users.vue")
  },
  {
    name: "admin-users___pl",
    path: "/pl/admin/users",
    meta: usersMvpEns61RVMeta || {},
    component: () => import("/codebuild/output/src3107083106/src/pages/admin/users.vue")
  },
  {
    name: "change-password___en",
    path: "/en/change-password",
    meta: change_45password2ELJJL3eBFMeta || {},
    component: () => import("/codebuild/output/src3107083106/src/pages/change-password.vue")
  },
  {
    name: "change-password___pl",
    path: "/pl/change-password",
    meta: change_45password2ELJJL3eBFMeta || {},
    component: () => import("/codebuild/output/src3107083106/src/pages/change-password.vue")
  },
  {
    name: chatt8owFJluyJMeta?.name,
    path: "/en/chat",
    meta: chatt8owFJluyJMeta || {},
    component: () => import("/codebuild/output/src3107083106/src/pages/chat.vue"),
    children: [
  {
    name: "chat-id___en",
    path: ":id()",
    meta: _91id_93RTuqx4jeCgMeta || {},
    component: () => import("/codebuild/output/src3107083106/src/pages/chat/[id].vue")
  },
  {
    name: "chat-ai___en",
    path: "ai",
    meta: aiMtmaoDalYdMeta || {},
    component: () => import("/codebuild/output/src3107083106/src/pages/chat/ai.vue")
  },
  {
    name: "chat___en",
    path: "",
    meta: indexouP9xF6C1rMeta || {},
    component: () => import("/codebuild/output/src3107083106/src/pages/chat/index.vue")
  }
]
  },
  {
    name: chatt8owFJluyJMeta?.name,
    path: "/pl/chat",
    meta: chatt8owFJluyJMeta || {},
    component: () => import("/codebuild/output/src3107083106/src/pages/chat.vue"),
    children: [
  {
    name: "chat-id___pl",
    path: ":id()",
    meta: _91id_93RTuqx4jeCgMeta || {},
    component: () => import("/codebuild/output/src3107083106/src/pages/chat/[id].vue")
  },
  {
    name: "chat-ai___pl",
    path: "ai",
    meta: aiMtmaoDalYdMeta || {},
    component: () => import("/codebuild/output/src3107083106/src/pages/chat/ai.vue")
  },
  {
    name: "chat___pl",
    path: "",
    meta: indexouP9xF6C1rMeta || {},
    component: () => import("/codebuild/output/src3107083106/src/pages/chat/index.vue")
  }
]
  },
  {
    name: "client-profile-id___en",
    path: "/en/client/profile/:id()",
    meta: _91id_93yiOe0D5BysMeta || {},
    component: () => import("/codebuild/output/src3107083106/src/pages/client/profile/[id].vue")
  },
  {
    name: "client-profile-id___pl",
    path: "/pl/client/profile/:id()",
    meta: _91id_93yiOe0D5BysMeta || {},
    component: () => import("/codebuild/output/src3107083106/src/pages/client/profile/[id].vue")
  },
  {
    name: "client-profile___en",
    path: "/en/client/profile",
    meta: index2rTWkhp226Meta || {},
    component: () => import("/codebuild/output/src3107083106/src/pages/client/profile/index.vue")
  },
  {
    name: "client-profile___pl",
    path: "/pl/client/profile",
    meta: index2rTWkhp226Meta || {},
    component: () => import("/codebuild/output/src3107083106/src/pages/client/profile/index.vue")
  },
  {
    name: contactsaHRPaC9duWMeta?.name,
    path: "/en/contacts",
    meta: contactsaHRPaC9duWMeta || {},
    component: () => import("/codebuild/output/src3107083106/src/pages/contacts.vue"),
    children: [
  {
    name: "contacts-id___en",
    path: ":id()",
    meta: _91id_93gH0g6juG0eMeta || {},
    component: () => import("/codebuild/output/src3107083106/src/pages/contacts/[id].vue")
  },
  {
    name: "contacts___en",
    path: "",
    meta: indexxucELfRYhiMeta || {},
    component: () => import("/codebuild/output/src3107083106/src/pages/contacts/index.vue")
  }
]
  },
  {
    name: contactsaHRPaC9duWMeta?.name,
    path: "/pl/contacts",
    meta: contactsaHRPaC9duWMeta || {},
    component: () => import("/codebuild/output/src3107083106/src/pages/contacts.vue"),
    children: [
  {
    name: "contacts-id___pl",
    path: ":id()",
    meta: _91id_93gH0g6juG0eMeta || {},
    component: () => import("/codebuild/output/src3107083106/src/pages/contacts/[id].vue")
  },
  {
    name: "contacts___pl",
    path: "",
    meta: indexxucELfRYhiMeta || {},
    component: () => import("/codebuild/output/src3107083106/src/pages/contacts/index.vue")
  }
]
  },
  {
    name: "delete-mailing-email-userId___en",
    path: "/en/delete-mailing/:email()/:userId()",
    meta: _91userId_93uITsG3PdWRMeta || {},
    component: () => import("/codebuild/output/src3107083106/src/pages/delete-mailing/[email]/[userId].vue")
  },
  {
    name: "delete-mailing-email-userId___pl",
    path: "/pl/delete-mailing/:email()/:userId()",
    meta: _91userId_93uITsG3PdWRMeta || {},
    component: () => import("/codebuild/output/src3107083106/src/pages/delete-mailing/[email]/[userId].vue")
  },
  {
    name: "index___en",
    path: "/en",
    meta: indexhlkLmcalOBMeta || {},
    component: () => import("/codebuild/output/src3107083106/src/pages/index.vue")
  },
  {
    name: "index___pl",
    path: "/pl",
    meta: indexhlkLmcalOBMeta || {},
    component: () => import("/codebuild/output/src3107083106/src/pages/index.vue")
  },
  {
    name: loginsJwveiBknHMeta?.name,
    path: "/en/login",
    component: () => import("/codebuild/output/src3107083106/src/pages/login.vue"),
    children: [
  {
    name: "login___en",
    path: "",
    meta: indexqaIlNMRcB4Meta || {},
    component: () => import("/codebuild/output/src3107083106/src/pages/login/index.vue")
  },
  {
    name: "login-register-success___en",
    path: "register-success",
    meta: register_45success7MceEp9INOMeta || {},
    component: () => import("/codebuild/output/src3107083106/src/pages/login/register-success.vue")
  }
]
  },
  {
    name: loginsJwveiBknHMeta?.name,
    path: "/pl/login",
    component: () => import("/codebuild/output/src3107083106/src/pages/login.vue"),
    children: [
  {
    name: "login___pl",
    path: "",
    meta: indexqaIlNMRcB4Meta || {},
    component: () => import("/codebuild/output/src3107083106/src/pages/login/index.vue")
  },
  {
    name: "login-register-success___pl",
    path: "register-success",
    meta: register_45success7MceEp9INOMeta || {},
    component: () => import("/codebuild/output/src3107083106/src/pages/login/register-success.vue")
  }
]
  },
  {
    name: "logout___en",
    path: "/en/logout",
    meta: logoutwpfPAmsAzFMeta || {},
    component: () => import("/codebuild/output/src3107083106/src/pages/logout.vue")
  },
  {
    name: "logout___pl",
    path: "/pl/logout",
    meta: logoutwpfPAmsAzFMeta || {},
    component: () => import("/codebuild/output/src3107083106/src/pages/logout.vue")
  },
  {
    name: "manager-consents___en",
    path: "/en/manager/consents",
    meta: consentsgGJNNNHtFFMeta || {},
    component: () => import("/codebuild/output/src3107083106/src/pages/manager/consents.vue")
  },
  {
    name: "manager-consents___pl",
    path: "/pl/manager/consents",
    meta: consentsgGJNNNHtFFMeta || {},
    component: () => import("/codebuild/output/src3107083106/src/pages/manager/consents.vue")
  },
  {
    name: "manager-integrations___en",
    path: "/en/manager/integrations",
    meta: integrations0IUq0AxXq8Meta || {},
    component: () => import("/codebuild/output/src3107083106/src/pages/manager/integrations.vue")
  },
  {
    name: "manager-integrations___pl",
    path: "/pl/manager/integrations",
    meta: integrations0IUq0AxXq8Meta || {},
    component: () => import("/codebuild/output/src3107083106/src/pages/manager/integrations.vue")
  },
  {
    name: "manager-leads___en",
    path: "/en/manager/leads",
    meta: leads18fB1uyBbgMeta || {},
    component: () => import("/codebuild/output/src3107083106/src/pages/manager/leads.vue")
  },
  {
    name: "manager-leads___pl",
    path: "/pl/manager/leads",
    meta: leads18fB1uyBbgMeta || {},
    component: () => import("/codebuild/output/src3107083106/src/pages/manager/leads.vue")
  },
  {
    name: "manager-payments___en",
    path: "/en/manager/payments",
    meta: paymentsN9uHDXlzzZMeta || {},
    component: () => import("/codebuild/output/src3107083106/src/pages/manager/payments.vue")
  },
  {
    name: "manager-payments___pl",
    path: "/pl/manager/payments",
    meta: paymentsN9uHDXlzzZMeta || {},
    component: () => import("/codebuild/output/src3107083106/src/pages/manager/payments.vue")
  },
  {
    name: "manager-profile___en",
    path: "/en/manager/profile",
    meta: profilev3jTCgIfYpMeta || {},
    component: () => import("/codebuild/output/src3107083106/src/pages/manager/profile.vue")
  },
  {
    name: "manager-profile___pl",
    path: "/pl/manager/profile",
    meta: profilev3jTCgIfYpMeta || {},
    component: () => import("/codebuild/output/src3107083106/src/pages/manager/profile.vue")
  },
  {
    name: "manager-team___en",
    path: "/en/manager/team",
    meta: teamH9P5hygSGxMeta || {},
    component: () => import("/codebuild/output/src3107083106/src/pages/manager/team.vue")
  },
  {
    name: "manager-team___pl",
    path: "/pl/manager/team",
    meta: teamH9P5hygSGxMeta || {},
    component: () => import("/codebuild/output/src3107083106/src/pages/manager/team.vue")
  },
  {
    name: marketplaceczvRPw0GanMeta?.name,
    path: "/en/marketplace",
    meta: marketplaceczvRPw0GanMeta || {},
    component: () => import("/codebuild/output/src3107083106/src/pages/marketplace.vue"),
    children: [
  {
    name: "marketplace___en",
    path: "",
    component: () => import("/codebuild/output/src3107083106/src/pages/marketplace/index.vue")
  },
  {
    name: "marketplace-search-catId___en",
    path: "search/:catId()",
    meta: _91catId_93_46clienttyfR4HsRzGMeta || {},
    component: () => createClientPage(() => import("/codebuild/output/src3107083106/src/pages/marketplace/search/[catId].client.vue"))
  }
]
  },
  {
    name: marketplaceczvRPw0GanMeta?.name,
    path: "/pl/marketplace",
    meta: marketplaceczvRPw0GanMeta || {},
    component: () => import("/codebuild/output/src3107083106/src/pages/marketplace.vue"),
    children: [
  {
    name: "marketplace___pl",
    path: "",
    component: () => import("/codebuild/output/src3107083106/src/pages/marketplace/index.vue")
  },
  {
    name: "marketplace-search-catId___pl",
    path: "search/:catId()",
    meta: _91catId_93_46clienttyfR4HsRzGMeta || {},
    component: () => createClientPage(() => import("/codebuild/output/src3107083106/src/pages/marketplace/search/[catId].client.vue"))
  }
]
  },
  {
    name: "newsletter-subscribe___en",
    path: "/en/newsletter/subscribe",
    meta: subscriber6fPE7EfbtMeta || {},
    component: () => import("/codebuild/output/src3107083106/src/pages/newsletter/subscribe.vue")
  },
  {
    name: "newsletter-subscribe___pl",
    path: "/pl/newsletter/subscribe",
    meta: subscriber6fPE7EfbtMeta || {},
    component: () => import("/codebuild/output/src3107083106/src/pages/newsletter/subscribe.vue")
  },
  {
    name: "orders-find___en",
    path: "/en/orders/find",
    meta: find_46client7iVhTlkgCZMeta || {},
    component: () => createClientPage(() => import("/codebuild/output/src3107083106/src/pages/orders/find.client.vue"))
  },
  {
    name: "orders-find___pl",
    path: "/pl/orders/find",
    meta: find_46client7iVhTlkgCZMeta || {},
    component: () => createClientPage(() => import("/codebuild/output/src3107083106/src/pages/orders/find.client.vue"))
  },
  {
    name: "orders-my___en",
    path: "/en/orders/my",
    meta: my_46clientkWD3z4TJfeMeta || {},
    component: () => createClientPage(() => import("/codebuild/output/src3107083106/src/pages/orders/my.client.vue"))
  },
  {
    name: "orders-my___pl",
    path: "/pl/orders/my",
    meta: my_46clientkWD3z4TJfeMeta || {},
    component: () => createClientPage(() => import("/codebuild/output/src3107083106/src/pages/orders/my.client.vue"))
  },
  {
    name: "privacy___en",
    path: "/en/privacy",
    meta: privacyRn7vsTG28rMeta || {},
    component: () => import("/codebuild/output/src3107083106/src/pages/privacy.vue")
  },
  {
    name: "privacy___pl",
    path: "/pl/privacy",
    meta: privacyRn7vsTG28rMeta || {},
    component: () => import("/codebuild/output/src3107083106/src/pages/privacy.vue")
  },
  {
    name: "recover___en",
    path: "/en/recover",
    meta: indexVePs0vlrVhMeta || {},
    component: () => import("/codebuild/output/src3107083106/src/pages/recover/index.vue")
  },
  {
    name: "recover___pl",
    path: "/pl/recover",
    meta: indexVePs0vlrVhMeta || {},
    component: () => import("/codebuild/output/src3107083106/src/pages/recover/index.vue")
  },
  {
    name: "register-success___en",
    path: "/en/register/success",
    component: () => import("/codebuild/output/src3107083106/src/pages/register/success.vue")
  },
  {
    name: "register-success___pl",
    path: "/pl/register/success",
    component: () => import("/codebuild/output/src3107083106/src/pages/register/success.vue")
  },
  {
    name: "sales-profile-id___en",
    path: "/en/sales/profile/:id()",
    meta: _91id_93VH4mjGPNt2Meta || {},
    component: () => import("/codebuild/output/src3107083106/src/pages/sales/profile/[id].vue")
  },
  {
    name: "sales-profile-id___pl",
    path: "/pl/sales/profile/:id()",
    meta: _91id_93VH4mjGPNt2Meta || {},
    component: () => import("/codebuild/output/src3107083106/src/pages/sales/profile/[id].vue")
  },
  {
    name: "sales-profile___en",
    path: "/en/sales/profile",
    meta: indexC9VJ54uKQaMeta || {},
    component: () => import("/codebuild/output/src3107083106/src/pages/sales/profile/index.vue")
  },
  {
    name: "sales-profile___pl",
    path: "/pl/sales/profile",
    meta: indexC9VJ54uKQaMeta || {},
    component: () => import("/codebuild/output/src3107083106/src/pages/sales/profile/index.vue")
  },
  {
    name: "statue___en",
    path: "/en/statue",
    meta: statueMShFAknGf4Meta || {},
    component: () => import("/codebuild/output/src3107083106/src/pages/statue.vue")
  },
  {
    name: "statue___pl",
    path: "/pl/statue",
    meta: statueMShFAknGf4Meta || {},
    component: () => import("/codebuild/output/src3107083106/src/pages/statue.vue")
  },
  {
    name: "subscription-success___en",
    path: "/en/subscription/success",
    meta: successynOBLG297JMeta || {},
    component: () => import("/codebuild/output/src3107083106/src/pages/subscription/success.vue")
  },
  {
    name: "subscription-success___pl",
    path: "/pl/subscription/success",
    meta: successynOBLG297JMeta || {},
    component: () => import("/codebuild/output/src3107083106/src/pages/subscription/success.vue")
  },
  {
    name: component_45stub6GkjTze17uMeta?.name,
    path: "/old-page",
    component: component_45stub6GkjTze17u
  }
]